import { render, staticRenderFns } from "./LoginViolation.vue?vue&type=template&id=508ff0d6&scoped=true&"
import script from "./LoginViolation.vue?vue&type=script&lang=js&"
export * from "./LoginViolation.vue?vue&type=script&lang=js&"
import style0 from "./LoginViolation.vue?vue&type=style&index=0&id=508ff0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ff0d6",
  null
  
)

export default component.exports